import React from "react";

export default function Marquee({ items, fast }) {
  const list = [...items, ...items, ...items, ...items];
  return (
    <div className="overflow-hidden bg-black text-white py-3">
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {list.map((t, i) => (
          <span
            key={i}
            className="mx-6 text-xs md:text-sm font-medium tracking-[0.3em] whitespace-nowrap flex items-center gap-6"
          >
            {t}
            <span className="text-neutral-500">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
